import { createContext, useContext } from "react";

export type SettingsSection = "household" | "location" | "members" | "calendar" | "display" | "ai" | "diagnostics";

export interface AppUi {
  openSettings: (section?: SettingsSection) => void;
  toast: (message: string, action?: { label: string; run: () => void }) => void;
  /** Switch to the screen made from this starter (shared/presets.ts); false if there is none or it's already showing. */
  openScreen: (presetKey: string) => boolean;
}

export const AppUiContext = createContext<AppUi>({
  openSettings: () => undefined,
  toast: () => undefined,
  openScreen: () => false,
});

export const useAppUi = () => useContext(AppUiContext);
